module.exports = __webpack_public_path__ + "img/user-man.485fcde0.png";